export default __webpack_public_path__ + "static/media/Angelina.0aaca350.jpeg";